// Function to highlight and match words between target and guess strings
function highlightMatch(target: string , guess:string) {
    // Split and convert to lowercase
    const targetWords = target.toLowerCase().replace(/[^\w\s]|_/g, "").split(' ');
    const guessWords = guess.toLowerCase().replace(/[^\w\s]|_/g, "").split(' ');
    const originalGuessWords = guess.replace(/[^\w\s]|_/g, "").split(' '); // 保存原始大小写的 guess words

    // Find matching positions for each guess word
    const guessWordsMatchPos = guessWords.map(word => {
        const pos = [];
        for (let i = 0; i < targetWords.length; i++) {
            if (targetWords[i] === word) {
                pos.push(i);
            }
        }
        return pos;
    });

    // Find maximum continuous linked sequences
    const iMaxLinkList = [];
    let i = 0;
    while (i < guessWordsMatchPos.length) {
        const posList = guessWordsMatchPos[i];
        let kMaxLinkList: number[] = [];
        let kMaxJ = i;
        let kMax = -1;

        for (let k = 0; k < posList.length; k++) {
            let iPos = posList[k];
            const linkList = [];
            let jPos = iPos;
            let j = i + 1;

            while (j < guessWordsMatchPos.length) {
                if (guessWordsMatchPos[j].includes(jPos + 1)) {
                    jPos += 1;
                    linkList.push(jPos);
                    if (j > kMaxJ) {
                        kMaxJ = j;
                        kMax = iPos;
                        kMaxLinkList = [...linkList];
                    }
                    j = j + 1;
                } else {
                    break;
                }
            }
        }

        // Handle different cases for kMaxLinkList
        if (kMax >= 0) {
            kMaxLinkList = [kMax, ...kMaxLinkList];
        } else if (posList.length > 0) {
            kMaxLinkList = [posList[0], ...kMaxLinkList];
        }

        iMaxLinkList.push(kMaxLinkList);
        i = kMaxJ + 1;
    }

    // Generate results with highlighting information
    let k = 0
    let guessWordIndex = 0;  // 用于追踪当前处理的 guess word 位置
    const results = iMaxLinkList.map((linkList, i) => {
       
        if (linkList.length > 0) {
            const words = linkList.map(() => {
                const word = originalGuessWords[guessWordIndex];
                guessWordIndex++;
                return word;
            }).join(' ');
            k += linkList.length
            let data = { words, type: 'green' };
            return data
        } else {
            let data = { words: guessWords[k], type: 'grey' };
            k += 1 
            guessWordIndex++;
            return data
        }
    });

    return results;
}

// Helper function to get CSS color class based on type
function getColor(type:string) {
    return type === 'green' ? 'bg-green-200' : 'bg-gray-200';
}

interface HighlightComponentProps {
    target: string;
    guess: string;
}
// Example usage with your React component:
const HighlightComponent: React.FC<HighlightComponentProps> = ({ target, guess }) => {
    const results = highlightMatch(target, guess);

    return (
        <div className="p-4 rounded-lg border border-gray-200">
            <div>
                <div className="mt-1">
                    {results.map((result, index) => (
                        <span key={index}>
                            <span className={`${getColor(result.type)} rounded px-1`}>
                            {result.words}
                            </span>
                            {" "}
                        </span>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default HighlightComponent;